import {getUserProperty} from '../selectors'
import type {UserProperty} from '../utils/userProperties'

import {useAppSelector} from './react-redux'

export function useUserProperty(name: UserProperty) {
  return useAppSelector(state => getUserProperty(state, name))
}

export function useBooleanUserProperty(name: UserProperty, defaultTrue?: boolean) {
  const value = useUserProperty(name)
  return defaultTrue ? value !== 'false' : value === 'true'
}
